import ErrorSubclass from 'util/ErrorSubclass';

export default class CreateUserDefinedViewException extends ErrorSubclass {}
